import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { format } from "date-fns";
import { ComponentProps } from "react";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { CertificateStatusEnum } from "../../../common/enums/CertificateStatusEnum";
import { getUserFullName } from "../../../common/utils/getUserFullName";

type DetailCardAlert = NonNullable<ComponentProps<typeof DetailCard>["alert"]>;

interface Props {
    certificate: CertificateInterface;
    activeTab: string;
}

export const getEmployeeCertificateCardAlert = (
    props: Props,
): DetailCardAlert | undefined => {
    const { certificate, activeTab } = props;

    if (activeTab !== CertificateStatusEnum.REJECTED || !certificate.comment) {
        return undefined;
    }

    return {
        variant: "rejected",
        date: format(certificate.reviewed_at, "dd-MM-yyyy"),
        by: getUserFullName(certificate.reviewer?.user) ?? "-",
        comment: certificate.comment,
    };
};
